/**
 * Meta (Facebook) Pixel — base loader + helpers.
 * Set REACT_APP_META_PIXEL_ID in .env (numeric ID from Meta Events Manager).
 */

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();

function canTrack() {
    return typeof window !== 'undefined' && typeof window.fbq === 'function';
}

export function isMetaPixelEnabled() {
    return PIXEL_ID.length > 0 || canTrack();
}

/** Official stub + script inject, then init + first PageView (call once). */
export function initMetaPixel() {
    if (typeof window === 'undefined' || !isMetaPixelEnabled()) return;
    if (window.__META_PIXEL_INITIALIZED__) return;
    const f = window;
    // index.html may already load Meta Pixel; do not inject or init twice.
    if (f.fbq) {
        window.__META_PIXEL_INITIALIZED__ = true;
        return;
    }
    if (!PIXEL_ID) return;
    window.__META_PIXEL_INITIALIZED__ = true;

    const b = document;
    const e = 'script';
    const v = 'https://connect.facebook.net/en_US/fbevents.js';
    let n;
    let t;
    let s;
    n = f.fbq = function fbqStub() {
        if (n.callMethod) {
            n.callMethod.apply(n, arguments);
        } else {
            n.queue.push(arguments);
        }
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
}

export function metaTrackPageView() {
    if (!canTrack()) return;
    window.fbq('track', 'PageView');
}

export function metaTrackViewContent(item) {
    if (!canTrack() || !item) return;
    window.fbq('track', 'ViewContent', {
        content_ids: [String(item.id)],
        content_type: 'product',
        content_name: item.name,
        value: Number(item.price),
        currency: 'EUR'
    });
}

export function metaTrackViewContentList(items, contentName) {
    if (!canTrack() || !items || !items.length) return;
    window.fbq('track', 'ViewContent', {
        content_ids: items.map((i) => String(i.id)),
        content_type: 'product',
        content_name: contentName,
        currency: 'EUR'
    });
}

export function metaTrackAddToCart(item) {
    if (!canTrack()) return;
    const qty = Number(item.quantity) || 1;
    const value = Number(item.price) * qty;
    window.fbq('track', 'AddToCart', {
        value: value,
        currency: 'EUR',
        contents: [
            {
                id: String(item.id),
                quantity: qty
            }
        ],
        content_ids: [String(item.id)],
        content_type: 'product',
        content_name: item.name
    });
}

export function metaTrackInitiateCheckout(cartItems, value) {
    if (!canTrack()) return;
    if (!cartItems || !cartItems.length) return;
    const numItems = cartItems.reduce((sum, i) => sum + (i.quantity || 1), 0);
    window.fbq('track', 'InitiateCheckout', {
        content_ids: cartItems.map((i) => String(i.id)),
        content_type: 'product',
        num_items: numItems,
        value: Number(value),
        currency: 'EUR'
    });
}

export function metaTrackPurchase(value, contentIds, numItems) {
    if (!canTrack()) return;
    window.fbq('track', 'Purchase', {
        value: Number(value),
        currency: 'EUR',
        content_ids: contentIds.map(String),
        content_type: 'product',
        num_items: numItems
    });
}

export function metaTrackCustomizeProduct(item, color) {
    if (!canTrack() || !item) return;
    window.fbq('track', 'CustomizeProduct', {
        content_ids: [String(item.id)],
        content_type: 'product',
        content_name: item.name,
        content_category: color ? String(color) : undefined
    });
}

export function metaTrackContact() {
    if (!canTrack()) return;
    window.fbq('track', 'Contact');
}

export function metaTrackLead() {
    if (!canTrack()) return;
    window.fbq('track', 'Lead');
}
